import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BannerContentDirective } from './banner-content.directive';


@NgModule({
    declarations: [BannerContentDirective],
    imports: [
        CommonModule
    ],
    exports: [
        BannerContentDirective
    ]
})
export class BannerContentModule {}
